import React from 'react'
import './Footer.css';
function Footer() {


  return (
    <div className='footer-container footer' data-scroll data-scroll-container>
      <h2 className="title" data-scroll data-scroll-speed="-1">Would you like to contact me?</h2>
      <div class="icons">
        <a href="https://www.linkedin.com/in/rodriguez-sabia/" target="_blank">
           <div class="layer">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span class="fab fa-linkedin-in"></span>
           </div>
           <div class="text">
              LinkedIn
           </div>
        </a>
        <a href="https://github.com/facundorsabia" target="_blank">
           <div class="layer">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span class="fab fa-github"></span>
           </div>
           <div class="text">
              Github
           </div>
        </a>
        <a href="mailto:facundorsabie@gmail.com" target="_blank">
           <div class="layer">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span class="fab fa-google"></span>
           </div>
           <div class="text">
              EMail
           </div>
        </a>
        <a href="https://wa.me/+541167431598" target="_blank">
           <div class="layer">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span class="fab fa-whatsapp"></span>
           </div>
           <div class="text">
              Whatsapp
           </div>
        </a>
     </div>
    </div>
  );
}

export default Footer;